module.exports = __webpack_public_path__ + "static/media/bts_lalela_170706_011_small.8b5142dc.jpg";